import React from 'react'
import Navegador from '../components/Navegador'
import Slider from '../components/Slider'
import NuestrasMarcas from '../components/NuestrasMarcas'

class Inicio extends React.Component {
    render(){
        return(
            <React.Fragment>
                <Navegador/>
                <Slider/>
                <NuestrasMarcas/>
            </React.Fragment>
        )
    }
}

export default Inicio